import Tippy from "@tippyjs/react";
import { ReactComponent as InfoIcon } from "../../../../assets/Icon feather-info.svg";
import "../../../dashboard/reservation-details/RoomTypesAccordian/room-units-accordian.css";
import "./styles.css";

function OverallPriceInfoToolTip({ overallPriceInfo = {} }) {
  return (
    <Tippy arrow={true} interactive={true} content={<CustomTooltipContent overallPriceInfo={overallPriceInfo} />} className="rd-overall-price-tooltip">
      <InfoIcon />
    </Tippy>
  );
}

export default OverallPriceInfoToolTip;

const CustomTooltipContent = ({ overallPriceInfo = {} }) => {
  const { tax: totalTax, taxRates, totalPrice, discount, hippoOfferAmount, grandTotal, currency } = overallPriceInfo;

  return (
    // using the same class using in units
    <div className="rd-accordian-price-tooltip-content">
      <div>
        <div className="rd-accordian-price-wrapper">
          <div>Total</div>
          <div>
            {currency} {totalPrice}
          </div>
        </div>
        <div className="rd-accordian-price-wrapper">
          <div>Discount</div>
          <div>
            {currency} {discount}
          </div>
        </div>

        {hippoOfferAmount > 0 && (
          <div className="rd-accordian-price-wrapper">
            <div>Hippo Offer</div>
            <div>
              {currency} {hippoOfferAmount}
            </div>
          </div>
        )}
      </div>
      <div className="rd-overall-price-tooltip-category">
        <div className="price-tooltip-category-heading">Taxes & Charges</div>
        {taxRates?.map((tax) => {
          return (
            <div className="rd-accordian-price-wrapper" key={tax.id}>
              <div>{tax.name}</div>
              <div>
                {currency} {tax.amount}
              </div>
            </div>
          );
        })}
        <div
          className="rd-accordian-price-wrapper"
          style={{
            marginTop: "4px",
          }}
        >
          <div>Total tax</div>
          <div>
            {currency} {totalTax}
          </div>
        </div>
      </div>

      <div className="rd-accordian-price-wrapper">
        <div>Final price</div>
        <div>
          {currency} {grandTotal}
        </div>
      </div>
    </div>
  );
};
